export enum PaymentProviderId {
  SC_Orbital_Crypto = '07d15c3e-35b3-11ed-8b0c-0a51dcb142a4',
  SC_Zotapay_Crypto = 'd25ea11c-9971-11ec-8b0c-0a51dcb142a4',
  SC_Zotapay_Crypto_Metablocks = 'f1f04084-2234-4672-88a2-89b11f3ed4a0',
  SC_BVNK_Crypto = 'd6f6284c-06d0-11ef-a132-0af8ef9e6807',
}

const isPaymentProviderSCOrbitalCrypto = (paymentProviderId: string | undefined): boolean => {
  return PaymentProviderId.SC_Orbital_Crypto === paymentProviderId
}

const isPaymentProviderSCZotapayCrypto = (paymentProviderId: string | undefined): boolean => {
  return PaymentProviderId.SC_Zotapay_Crypto === paymentProviderId
}

const isPaymentProviderSCZotapayCryptoMetablocks = (
  paymentProviderId: string | undefined
): boolean => {
  return PaymentProviderId.SC_Zotapay_Crypto_Metablocks === paymentProviderId
}

const isPaymentProviderSCBVNKCrypto = (paymentProviderId: string | undefined): boolean => {
  return PaymentProviderId.SC_BVNK_Crypto === paymentProviderId
}

export const getCryptoPaymentProviderFlags = (
  paymentProviderId?: string
): {
  isOrbitalCryptoProvider: boolean
  isZotapayCryptoProvider: boolean
  isZotapayMetablocksCryptoProvider: boolean
  isBVNKCryptoProvider: boolean
} => ({
  isOrbitalCryptoProvider: isPaymentProviderSCOrbitalCrypto(paymentProviderId),
  isZotapayCryptoProvider: isPaymentProviderSCZotapayCrypto(paymentProviderId),
  isZotapayMetablocksCryptoProvider: isPaymentProviderSCZotapayCryptoMetablocks(paymentProviderId),
  isBVNKCryptoProvider: isPaymentProviderSCBVNKCrypto(paymentProviderId),
})

export const isCryptoDepositInfoPaymentProvider = (paymentProviderId?: string): boolean => {
  const {
    isOrbitalCryptoProvider,
    isZotapayCryptoProvider,
    isZotapayMetablocksCryptoProvider,
    isBVNKCryptoProvider,
  } = getCryptoPaymentProviderFlags(paymentProviderId)

  return (
    isOrbitalCryptoProvider ||
    isZotapayCryptoProvider ||
    isZotapayMetablocksCryptoProvider ||
    isBVNKCryptoProvider
  )
}
